import React, { useState, useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import { Carousel } from 'react-bootstrap';
import './ReadingActivity.css';
import { addTooltipsToText } from "../tooltipUtils.jsx";
import VocabularyMatch from "../vocabmatchcolumn.jsx";
import vocabData from "../../Components/VocabularyListComps/Data/vocabcolumn.json";
import { FaAngleDown } from 'react-icons/fa';
import SEO, { SITE_NAME } from '../../Components/SEO';

const ReadingActivity = ({ data, skipSEO }) => {
  const [answers, setAnswers] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isGridVisible, setIsGridVisible] = useState(true);
  const [showVocab, setShowVocab] = useState(false);
  const topicMenuRef = useRef(null);

  useEffect(() => {
    if (data?.paragraphs?.[0]?.questions?.length) {
      const qCount = data.paragraphs[0].questions.length;
      setAnswers(Array(qCount).fill(''));
    }
  }, [data]);

  const handleAnswerChange = (questionIndex, choice) => {
    const updated = [...answers];
    updated[questionIndex] = choice;
    setAnswers(updated);
    setShowResults(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  const isCorrect = (qIdx) =>
    answers[qIdx] === data?.paragraphs?.[0]?.questions?.[qIdx]?.correctAnswer;

  const getResultIcon = (qIdx, cIdx) => {
    if (!showResults) return null;
    const choice = data?.paragraphs?.[0]?.questions?.[qIdx]?.choices?.[cIdx];
    if (isCorrect(qIdx) && answers[qIdx] === choice) {
      return <span style={{ color: 'green' }}>&#10003;</span>;
    } else if (!isCorrect(qIdx) && answers[qIdx] === choice) {
      return <span style={{ color: 'red' }}>&#10005;</span>;
    }
    return null;
  };

  const toggleGridVisibility = () => setIsGridVisible((prev) => !prev);
  const toggleVocab = () => setShowVocab((prev) => !prev);
  const closeVocab = () => setShowVocab(false);

  if (!data) {
    return <div>Loading reading...</div>;
  }

  return (
      <div className="readingActivity-container">
        {!skipSEO && (
        <SEO
          title={`English Reading Exercise: ${data?.readingcompTitle || data?.title || 'Reading Practice'}`}
          description="Free English reading exercise with multiple-choice comprehension questions and vocabulary support."
          name={SITE_NAME}
          type="article"
        />
      )}
        <form className="readingActivityform" onSubmit={handleSubmit}>
             <div className="reading-image">
                    <img src={data.image} alt="title" />
                </div>
          <div className="readingActivity-text">
            <h3 className="readingTitle">{data.readingcompTitle}</h3>
            {data.paragraphs?.map((p, idx) => (
              <div
                key={idx}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(addTooltipsToText(p.text, data.vocabulary)),
                }}
              />
            ))}
          </div>

          <div className="question-container">
            <Carousel interval={null} wrap={false} controls indicators={false} pause="hover">
              {data.paragraphs?.[0]?.questions?.map((q, qIdx) => (
                <Carousel.Item key={qIdx}>
                  <div className="question">
                    {q.number}. {q.question}
                  </div>
                  <div className="choices-container">
                    {q.choices.map((choice, cIdx) => (
                      <label key={cIdx}>
                        <input
                          type="radio"
                          value={choice}
                          checked={answers[qIdx] === choice}
                          onChange={() => handleAnswerChange(qIdx, choice)}
                        />
                        {choice}
                        {getResultIcon(qIdx, cIdx)}
                      </label>
                    ))}
                  </div>
                  <button type="submit" className="checkbtn">
                    Check Answer
                  </button>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          {showVocab && (
            <div className="overlay" onClick={closeVocab}>
              <div className="transcript-overlay" onClick={(e) => e.stopPropagation()}>
                <div className="vocabulary-text">
                  {data.vocabulary?.length ? (
                    <ul>
                      {data.vocabulary.map((item, idx) => (
                        <li key={idx} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
                      ))}
                    </ul>
                  ) : (
                    <p>No vocabulary available for this reading.</p>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="readingActivity-vocab-header-box" onClick={toggleGridVisibility}>
            Vocabulary <FaAngleDown />
          </div>
          {isGridVisible && (
            <div className="readingActivity-display-grid">
                  {data.vocabulary?.length ? (
                    <ul>
                      {data.vocabulary.map((item, idx) => (
                        <li key={idx} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item) }} />
                      ))}
                    </ul>
                  ) : (
                    <p>No vocabulary available for this reading.</p>
                  )}
            </div>
          )}


        </form>
      </div>
    
  );
};

export default ReadingActivity;
